import { Injectable } from '@angular/core';
import * as tf from '@tensorflow/tfjs';

@Injectable({
  providedIn: 'root'
})
export class TensorflowModelService {
  private model: tf.LayersModel | tf.GraphModel | null = null;
  private modelLoaded = false;

  constructor() { }

  async loadModel(modelPath: string): Promise<void> {
    try {
      console.log('Cargando modelo desde:', modelPath);
      
      // Intenta cargar como GraphModel primero (más común para modelos convertidos)
      try {
        this.model = await tf.loadGraphModel(modelPath);
        console.log('Modelo cargado como GraphModel');
      } catch (graphError) {
        console.log('No se pudo cargar como GraphModel, intentando LayersModel...');
        this.model = await tf.loadLayersModel(modelPath);
        console.log('Modelo cargado como LayersModel');
      }
      
      this.modelLoaded = true;
      console.log('Modelo cargado exitosamente');
      console.log('Inputs:', this.model.inputs);
      console.log('Outputs:', this.model.outputs);
    } catch (error) {
      console.error('Error al cargar el modelo:', error);
      throw error;
    }
  }

  async predict(inputData: number[] | number[][] | number[][][]): Promise<any> {
    if (!this.modelLoaded || !this.model) {
      throw new Error('El modelo no está cargado');
    }

    try {
      // Convierte los datos de entrada a tensor
      let inputTensor = tf.tensor(inputData);
      
      // Si el modelo espera un batch dimension, agrégalo
      const inputShape = this.model.inputs[0].shape;
      console.log('Shape esperado:', inputShape);
      console.log('Shape del input:', inputTensor.shape);
      
      // Realiza la predicción
      const prediction = this.model.predict(inputTensor);
      
      let result;
      // Maneja múltiples outputs
      if (Array.isArray(prediction)) {
        result = await Promise.all(prediction.map((p: tf.Tensor) => p.array()));
      } else {
        result = await (prediction as tf.Tensor).array();
      }
      
      // Limpia los tensores para liberar memoria
      inputTensor.dispose();
      if (Array.isArray(prediction)) {
        prediction.forEach((p: tf.Tensor) => p.dispose());
      } else {
        (prediction as tf.Tensor).dispose();
      }
      
      return result;
    } catch (error) {
      console.error('Error al realizar la predicción:', error);
      throw error;
    }
  }

  getModelInfo(): any {
    if (!this.model) {
      return null;
    }

    return {
      inputs: this.model.inputs.map((input: any) => ({
        name: input.name,
        shape: input.shape
      })),
      outputs: this.model.outputs.map((output: any) => ({
        name: output.name,
        shape: output.shape
      }))
    };
  }

  isModelLoaded(): boolean {
    return this.modelLoaded;
  }
}
